export default {
      id: "microphone-usage",
      viewBox: "0 0 15 23",
      url: __webpack_public_path__ + "img/icons.svg#microphone",
      toString: function () {
        return this.url;
      }
    }